import { v4 as uuid } from 'uuid';

function getAWSPath(directory: string, id: string, type: string) {
	return `${directory}/${id}/${type}_${new Date().toISOString()}_${uuid()}`;
}

export { getAWSPath };
